import ImageResponsive from './image_responsive';
export default ImageResponsive;
